import { defineAsyncComponent } from 'vue';
import VueToast from 'vue-toast-notification';
import { mountApp, app } from '@/js/app-entries/app-entry-points/global';
import 'vue-toast-notification/dist/theme-sugar.css';

const VolumeChart = defineAsyncComponent(() => import('@/js/exchanges/VolumeChart.vue'));
const ShareTippy = defineAsyncComponent(() => import('@/js/components/Tippy/ShareTippy/ShareTippy.vue'));
const LearnListButton = defineAsyncComponent(() => import('@/js/global/buttons/LearnListButton.vue'));
const SocialsChart = defineAsyncComponent(() => import('@/js/other/SocialsChart.vue'));

app.use(VueToast);

app.component('VolumeChart', VolumeChart);
app.component('LearnListButton', LearnListButton);
app.component('ShareTippy', ShareTippy);
app.component('SocialsChart', SocialsChart);

mountApp();
